export const componentTypes = {
  text: 'text',
  image: 'image',
  div: 'div',
};
